export default "__VITE_ASSET__BtwiVi1D__"